import Layout from "components/Layout"

const NotAllowed = () => {
  return (
    <Layout title="403 Error" content="403 Error Page">
      <div>You do not have the appropriate permissions!</div>
    </Layout>
  )
}

export default NotAllowed
